import React from 'react'
import TrackerDashboard from '../components/TrackerDashboard'

const Applications = () => {
  return <TrackerDashboard />
}

export default Applications
